import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const navLinks = [
  { label: "Sobre el Autor", href: "#autor" },
  { label: "La Historia", href: "#historia" },
  { label: "Por qué leerlo", href: "#por-que" },
  { label: "Contacto", href: "#cierre" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      className="fixed top-0 left-0 w-full z-50 transition-all duration-500"
      style={{
        background: scrolled ? "rgba(0,29,62,0.97)" : "transparent",
        backdropFilter: scrolled ? "blur(12px)" : "none",
        borderBottom: scrolled ? "1px solid rgba(212,175,55,0.2)" : "none"
      }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-16 flex items-center justify-between h-16 md:h-20">

        {/* Logo */}
        <a
          href="#hero"
          onClick={e => { e.preventDefault(); handleNavClick("#hero"); }}
          className="flex items-center gap-3 cursor-pointer"
        >
          <img
            src="https://static.readdy.ai/image/be4637b51fa2c7a7dcdb39fcd9b97fd2/5faa96864b94acad4f6acb77240d3382.png"
            alt="El Secuestro de Lucho"
            className="h-10 md:h-12 w-auto object-contain"
          />
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          <Link
            to="/libro"
            className="text-sm font-medium transition-colors duration-300 cursor-pointer whitespace-nowrap"
            style={{ color: "rgba(255,255,255,0.75)", letterSpacing: "0.5px" }}
            onMouseEnter={e => (e.currentTarget as HTMLAnchorElement).style.color = "#D4AF37"}
            onMouseLeave={e => (e.currentTarget as HTMLAnchorElement).style.color = "rgba(255,255,255,0.75)"}
          >
            El Libro
          </Link>
          {navLinks.map(link => (
            <a
              key={link.href}
              href={link.href}
              onClick={e => { e.preventDefault(); handleNavClick(link.href); }}
              className="text-sm font-medium transition-colors duration-300 cursor-pointer whitespace-nowrap"
              style={{ color: "rgba(255,255,255,0.75)", letterSpacing: "0.5px" }}
              onMouseEnter={e => (e.currentTarget as HTMLAnchorElement).style.color = "#D4AF37"}
              onMouseLeave={e => (e.currentTarget as HTMLAnchorElement).style.color = "rgba(255,255,255,0.75)"}
            >
              {link.label}
            </a>
          ))}
          <a
            href="https://books2read.com/el-secuestro-de-lucho"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-sm font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer"
            style={{
              background: "linear-gradient(135deg, #D4AF37, #F0D060)",
              color: "#002D62",
              padding: "10px 22px",
              borderRadius: "50px"
            }}
            onMouseEnter={e => (e.currentTarget as HTMLAnchorElement).style.transform = "translateY(-2px)"}
            onMouseLeave={e => (e.currentTarget as HTMLAnchorElement).style.transform = "translateY(0)"}
          >
            <i className="ri-amazon-fill" />
            Comprar
          </a>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <i className={`${menuOpen ? "ri-close-line" : "ri-menu-3-line"} text-2xl`} style={{ color: "#D4AF37" }} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div
          className="md:hidden px-6 pb-6 flex flex-col gap-4"
          style={{ background: "rgba(0,29,62,0.98)", borderTop: "1px solid rgba(212,175,55,0.2)" }}
        >
          <Link
            to="/libro"
            onClick={() => setMenuOpen(false)}
            className="text-sm font-medium py-2 cursor-pointer transition-colors duration-300"
            style={{ color: "rgba(255,255,255,0.8)" }}
          >
            El Libro
          </Link>
          {navLinks.map(link => (
            <a
              key={link.href}
              href={link.href}
              onClick={e => { e.preventDefault(); handleNavClick(link.href); }}
              className="text-sm font-medium py-2 cursor-pointer transition-colors duration-300"
              style={{ color: "rgba(255,255,255,0.8)" }}
            >
              {link.label}
            </a>
          ))}
          <a
            href="https://books2read.com/el-secuestro-de-lucho"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 text-sm font-semibold py-3 rounded-full whitespace-nowrap cursor-pointer"
            style={{ background: "linear-gradient(135deg, #D4AF37, #F0D060)", color: "#002D62" }}
          >
            <i className="ri-amazon-fill" />
            Comprar en Amazon
          </a>
        </div>
      )}
    </nav>
  );
}
